import React from 'react'
import { SanityPersonContacts } from '../../../../../types/generated/graphql-types'
import { mapSanityPersonContactsToFundsContactPersonsSection } from '../../../../mapping/FundsContactPersonsSectionMapper'
import { mapSanityPersonContactsToMarketContactPersonsSection } from '../../../../mapping/MarketContactPersonsSectionMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { IS_EQT_FUNDS } from '../../../../utilities/site'
import { FundsContactPersonsSection } from '../../../blocks/funds/FundsContactPersonsSection'
import { MarketContactPersonsSection } from '../../../blocks/market/MarketContactPersonsSection'

export type PersonContactsSerializerProps = SanityPersonContacts & BlockWithId

export const PersonContactsSerializer = ({
  id,
  ...props
}: PersonContactsSerializerProps) => {
  if (IS_EQT_FUNDS) {
    return (
      <FundsContactPersonsSection
        {...mapSanityPersonContactsToFundsContactPersonsSection(props)}
        id={id}
      />
    )
  }
  return (
    <MarketContactPersonsSection
      {...mapSanityPersonContactsToMarketContactPersonsSection(props)}
    />
  )
}
